export default "__VITE_ASSET__DwvduoKJ__"